import React from 'react';

const BsRow = (props) => (
	<div className={['row', props.class].join(' ')} style={props.style}>
		{props.children}
	</div>
);

export default BsRow;
